import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  did_you_mean: {
    defaultMessage: 'Did you mean {suggestedQuery}?',
  },
  search_instead_for: {
    defaultMessage:
      'These are results for "{suggestedQuery}", search instead for {originalQuery}',
  },
});
